import { useTranslation } from 'react-i18next';
import { Badge, type BadgeVariant } from '@/components/ui/badge';
import type { DdsStatus } from '@/types/core/transit/transit';

const STATUS_VARIANTS: Record<DdsStatus | 'not_required', BadgeVariant> = {
  pending: 'blue',
  submitted: 'gray',
  accepted: 'green',
  rejected: 'red',
  error: 'red',
  not_required: 'gray',
};

export function DdsStatusBadge({
  status,
  showLabel = false,
  label,
}: {
  status: DdsStatus | 'not_required';
  showLabel?: boolean;
  label?: string;
}) {
  const { t } = useTranslation('transits');

  return (
    <Badge className='h-8 rounded-full px-4' variant={STATUS_VARIANTS[status]}>
      {showLabel && `${t('ddsStatusLabel')}: `}
      {label ?? t(`ddsStatus.${status}`)}
    </Badge>
  );
}
